import { SxStyle } from '../../../types/style';

const contentContainer: SxStyle = {
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentContainerGridItem1Typography: SxStyle = {
    fontWeight: '700'
};

const contentContainerGridItem2Box: SxStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
};

const contentContainerGridItem2BoxButton: SxStyle = {
    marginRight: '8px'
};

const contentContainerGridItem3Paper: SxStyle = {
    padding: '16px'
};

//
const contentContainerGridItem3PaperGridItem1Typography: SxStyle = {
    fontWeight: 600
};

const contentContainerGridItem3PaperGridItem2ItemBox: SxStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
};

//
const contentContainerGridItem3PaperGridItem3Typography: SxStyle = {
    fontWeight: 600
};

//
const contentContainerGridItem3PaperGridItem4Typography: SxStyle = {
    fontWeight: 600
};

const contentContainerGridItem3PaperGridItem5Item1Box: SxStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
};

const contentContainerGridItem3PaperGridItem5Item2Stack: SxStyle = {
    marginRight: '16px'
};

const contentContainerGridItem3PaperGridItem5Item3Box: SxStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
};

const contentContainerGridItem3PaperGridItem5Item4Stack: SxStyle = {
    marginRight: '16px'
};

//
const contentContainerGridItem3PaperGridItem6Typography: SxStyle = {
    fontWeight: 600
};


// Datepicker
const datepickerError: SxStyle = {
    '& fieldset': { borderColor: '#CD1818' }
};


export const editProjectStyle = {
    contentContainer,
    contentContainerGridItem1Typography,
    contentContainerGridItem2Box,
    contentContainerGridItem2BoxButton,
    contentContainerGridItem3Paper,
    contentContainerGridItem3PaperGridItem1Typography,
    contentContainerGridItem3PaperGridItem2ItemBox,
    contentContainerGridItem3PaperGridItem3Typography,
    contentContainerGridItem3PaperGridItem4Typography,
    contentContainerGridItem3PaperGridItem5Item1Box,
    contentContainerGridItem3PaperGridItem5Item2Stack,
    contentContainerGridItem3PaperGridItem5Item3Box,
    contentContainerGridItem3PaperGridItem5Item4Stack,
    contentContainerGridItem3PaperGridItem6Typography,
    datepickerError
};